import React, {useContext, useEffect, useState, useMemo} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import TablePagination from '../../TablePagination';
import InputFilter from '../../Filters/InputFilter';
import SelectComponent from '../../Selects/SelectFilter';
import moment from 'moment';
import Datepicker from 'react-tailwindcss-datepicker';
import NotFound from '../../NotFound';

function HistoricoStatus({historicoStatus, negocioData}) {
    const {t} = useTranslation();
    const [currentPage, setCurrentPage] = useState(1);
    const ITEMS_PER_PAGE = 10;
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    historicoStatus.sort((a, b) => moment(b.data).valueOf() - moment(a.data).valueOf());
    const itemsToShow = historicoStatus.slice(startIndex, endIndex);

    // FILTROS
    const [filtroDt, setFiltroDt] = useState({
        startDate: '',
        endDate: '',
    });
    const [filtroDescricao, setFiltroDescricao] = useState('');
    const [filtroMotivo, setFiltroMotivo] = useState('');
    const [filtroRepresentante, setFiltroRepresentante] = useState('');

    const [formattedDate, setFormattedDate] = useState('');
    const [semDados, setSemDados] = useState(false);

    function GetDateTime(dateTime) {
        const dataHoraFormatada = moment(dateTime).format('DD/MM/YYYY HH:mm');
        return dataHoraFormatada;
    }

    useEffect(() => {
        if (filtroDt.startDate == null) {
            setFormattedDate('');
            return;
        }
        const originalDate = filtroDt.startDate;
        const parts = originalDate?.split('-');
        const formadata = `${parts[2]}/${parts[1]}/${parts[0]}`;
        setFormattedDate(parts[2] == undefined ? '' : formadata);
    }, [filtroDt]);

    const statusHistoricoFilt = itemsToShow.filter(
        x =>
            x.descricao?.toUpperCase().includes(filtroDescricao?.toUpperCase()) &&
            x.motivo?.toUpperCase().includes(filtroMotivo?.toUpperCase()) &&
            x.utilizador?.toUpperCase().includes(filtroRepresentante?.toUpperCase()) &&
            GetDateTime(x.data)?.toUpperCase().includes(formattedDate?.toUpperCase()),
    );

    useEffect(() => {
        if (statusHistoricoFilt.length != 0) {
            setSemDados(false);
        } else {
            setSemDados(true);
        }
    }, [statusHistoricoFilt]);

    return (
        <>
            <div>
                <div className="relative min-h-[300px] overflow-x-auto shadow-md sm:rounded-[8px]">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                            <tr>
                                <th scope="col" className="px-6 py-3">
                                    {t('data')}/ {t('hora')}
                                    <Datepicker
                                        displayFormat="DD/MM/YYYY"
                                        useRange={false}
                                        asSingle={true}
                                        value={filtroDt}
                                        onChange={newValue => {
                                            setFiltroDt(newValue);
                                        }}
                                        inputClassName={`rounded-[8px] mt-2 w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                    />
                                </th>

                                <th scope="col" className="px-6 py-3">
                                    {t('descricao')}
                                    <InputFilter
                                        onSearch={value => {
                                            setFiltroDescricao(value);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('motivo')}
                                    <InputFilter
                                        onSearch={value => {
                                            setFiltroMotivo(value);
                                        }}
                                    />
                                </th>
                                <th scope="col" className="px-6 py-3">
                                    {t('representante')}
                                    <InputFilter
                                        onSearch={value => {
                                            setFiltroRepresentante(value);
                                        }}
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {statusHistoricoFilt?.map(dados => (
                                <tr className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 ">
                                    <th scope="row" className="flex flex-row items-center px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {GetDateTime(dados.data)}
                                    </th>
                                    <td className="px-6 py-1">{dados.descricao}</td>
                                    <td className="px-6 py-1">{dados.motivo ? dados.motivo : '-'}</td>
                                    <td className="px-6 py-1">{dados.utilizador}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div>

                    {/* {totalProdutos === undefined && (
                <NotFound frase={t("naoExistemClientes")} />
              )}
    
              {loading && (
                <div className="flex flex-row mt-14 justify-center">
                  <>
                    <Spinner />
                  </>
                </div>
              )} */}

                   

                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(historicoStatus.length / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{historicoStatus.length}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        <TablePagination total={historicoStatus.length} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                    </nav>
                </div>
            </div>
        </>
    );
}

export default HistoricoStatus;
